import { styled } from '@mui/material';
import { motion } from 'framer-motion';

export const StyledSvg = styled(motion.svg)(({ theme: { palette } }) => ({
  width: '100%',
  height: '100%',
  color: palette.primary.main,

  '& path': {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.3,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
}));
